import { CONTENT_INLINE_MARGIN, CONTENT_MARGIN_BOTTOM } from '../../constants/styling';
import { CategoryHeader } from './CategoryHeader';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LockedCategory = ({
  id,
  labelKey
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    inlineSize: "100%",
    marginBlockEnd: CONTENT_MARGIN_BOTTOM,
    children: [/*#__PURE__*/_jsx(CategoryHeader, {
      id: id,
      labelKey: labelKey,
      seeAll: false,
      hasAccess: false
    }), /*#__PURE__*/_jsx(Flex, {
      backgroundColor: "fill-primary-disabled",
      blockSize: "400px",
      marginInline: CONTENT_INLINE_MARGIN
    })]
  });
};